import axios from "axios";
import { fetchNewToken, logoutUser } from "../actions/auth";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils";
import {
  FETCH_NEW_TOKEN,
  FETCH_TOKEN,
  FORGOT_PASSWORD_SEND_SMS,
  FORGOT_PASSWORD_UPDATE_PASSWORD,
  FORGOT_PASSWORD_VERIFY_CODE,
  LOGOUT,
} from "../constants/auth";
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../constants";

const apiMiddleware = (store) => (next) => async (action) => {
  if (!action.api) return next(action);
  const {
    url,
    params,
    data: requestData,
    method = "GET",
    baseURL = action.usePapi ? process.env.REACT_APP_PUBLIC_API_BASE_URL : process.env.REACT_APP_API_BASE_URL,
  } = action.payload;

  const requestType = getRequestActionType(action.type);
  const successType = getSuccessActionType(action.type);
  const failureType = getFailureActionType(action.type);

  next({ ...action, type: requestType });

  function handleSuccessRequest(data) {
    return next({ ...action, type: successType, payload: data });
  }

  function handleFailureRequest(errorMessage, forceLogout = true) {
    next({ ...action, type: failureType, payload: errorMessage, error: true });
    if (forceLogout) {
      store.dispatch(logoutUser());
    }
    return Promise.reject(errorMessage);
  }

  let headers = { "Cache-Control": "no-cache" };
  let accessToken;
  if (action.type === FETCH_TOKEN || action.type === LOGOUT) {
    accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  } else {
    accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  }
  const notRequiredTokenActions = [
    FETCH_TOKEN,
    FORGOT_PASSWORD_SEND_SMS,
    FORGOT_PASSWORD_VERIFY_CODE,
    FORGOT_PASSWORD_UPDATE_PASSWORD,
  ];

  if (!notRequiredTokenActions.includes(action.type) && !accessToken) {
    return handleFailureRequest("token not found!", true);
  }
  if (!notRequiredTokenActions.includes(action.type)) headers.Authorization = `Bearer ${accessToken}`;

  delete action.api;
  delete action.usePapi;
  const request = {
    baseURL,
    url,
    method,
    data: requestData,
    params,
    headers,
  };

  if (request.method !== "GET") {
    request.headers["Content-Type"] = "application/json";
  }

  try {
    const { data } = await axios(request);
    return handleSuccessRequest(data);
  } catch (error) {
    if (action.type === FETCH_NEW_TOKEN) {
      return handleFailureRequest("refresh token expired!", true);
    }

    if (!error.response || error.response.status !== 401 || action.type === FETCH_TOKEN) {
      return handleFailureRequest(error, false);
    }

    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (!refreshToken) return handleFailureRequest("refresh token not found!", true);
    const {
      payload: {
        access: { token: accessToken },
      },
    } = await store.dispatch(fetchNewToken(refreshToken));
    if (!accessToken) return handleFailureRequest("token expired!", true);
    request.headers.Authorization = `Bearer ${accessToken}`;
    try {
      const { data } = await axios(request);
      return handleSuccessRequest(data);
    } catch (error) {
      return handleFailureRequest(error, false);
    }
  }
};

export default apiMiddleware;
